// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1usg-","head":"Table_head__1C6cY","col":"Table_col__1GVnC"};